// Path: ./src/app/pages/CreateBannerPage/styled.ts
import styled from "styled-components";

import { token } from "../../components/FormKit/styled";

export const ImageSlot = styled.div<{ $disabled?: boolean; $filled?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 148px;
  border: 1px ${(props) => (props.$filled ? "solid" : "dashed")}
    ${(props) => (props.$filled ? token.color.border : token.color.borderStrong)};
  border-radius: ${token.radius.md};
  background: ${(props) =>
    props.$filled ? token.color.canvas : token.color.surface};
  overflow: hidden;
  transition:
    border-color 0.15s ease,
    background 0.15s ease;
  opacity: ${(props) => (props.$disabled ? 0.45 : 1)};
  pointer-events: ${(props) => (props.$disabled ? "none" : "auto")};

  &:hover {
    border-color: ${token.color.accent};
  }
`;

export const ImageSlotButton = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${token.space.sm};
  width: 100%;
  min-height: 148px;
  cursor: pointer;
  font-size: 13px;
  color: ${token.color.textMuted};
`;

export const ImageSlotPreview = styled.img`
  width: 100%;
  max-height: 180px;
  object-fit: contain;
  display: block;
`;

export const ImageSlotOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.75);
`;
